import { Box, Row } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';

import { FooterForegroundBox } from './Footer';

const FooterAppDownload = ({
  appleStoreLink,
  appleStoreImageUrl,
  googlePlaystoreLink,
  googlePlayStoreImageUrl,
  locale,
}: {
  appleStoreLink: string;
  appleStoreImageUrl: string;
  googlePlaystoreLink: string;
  googlePlayStoreImageUrl: string;
  locale?: string;
}) => (
  <FooterForegroundBox title="Get the app">
    <Row className="flex-wrap items-center justify-center gap-2 md:justify-end">
      <Box
        href={appleStoreLink}
        aria-label="Opendoor Applestore button"
        analyticsName="cosmos-landing-page-v2-footer-applesotre-button"
        className="inline-flex"
      >
        <Image src={appleStoreImageUrl} alt="Opendoor Applestore" width={135} height={45} />
      </Box>
      <Box
        href={googlePlaystoreLink}
        aria-label="Opendoor Google play button"
        analyticsName="cosmos-landing-page-v2-footer-googlgplay-button"
        className="inline-flex"
      >
        <Image
          src={googlePlayStoreImageUrl}
          alt="Opendoor Google Play"
          width={locale === 'es' ? 150 : 135}
          height={45}
        />
      </Box>
    </Row>
  </FooterForegroundBox>
);

export default FooterAppDownload;
